export default __webpack_public_path__ + "static/Surt-Regular-8bf40a2f21291f886480590be24724a4.woff2";